<template>
  <section id="your-sponsorship"
           v-bind:class="pipesInBasket ? 'uk-padding-large uk-padding-remove-horizontal': ''"
  >
    <template v-if="pipesInBasket">
      <div class="uk-container uk-container-large">
        <div class="uk-align-center uk-width-1-1 uk-width-2-3@m">
          <h2 class="uk-h2">Ihre Patenschaft</h2>
          <table class="uk-table uk-table-striped uk-table-hover uk-table-responsive">
            <thead>
            <tr>
              <th class="register">Register</th>
              <th class="tone">Pfeife</th>
              <th class="price">Spendenbetrag</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="p in sponsorship.pipes" v-bind:key="p.id">
                <td class="register">
                  <span class="uk-hidden@m uk-text-bold">Register: </span>{{p.register}}
                </td>
                <td class="tone">
                  <span class="uk-hidden@m uk-text-bold">Pfeife: </span>{{p.tone}}
                </td>
                <td class="price">
                  <span class="uk-hidden@m uk-text-bold">Spendenbetrag: </span>{{p.price.amount}} €
                </td>
                <td class="remove uk-table-link">
                  <a href="#" v-on:click.prevent="removePipe(p)">l&ouml;schen <span class="uk-icon-button" data-uk-icon="icon: close"></span></a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td id="grand-total" colspan="4">
                  <span class="uk-text-bold">Spendenbetrag gesamt {{ grandTotal }} €</span>
                </td>
              </tr>
            </tfoot>
          </table>
          <div id="button-container" class="uk-flex uk-flex-column uk-margin-medium-top">
            <a class="uk-button uk-button-default uk-button-large uk-text-large uk-align-center"
               v-on:click="showCheckout(true)"
            >
              Klangpatenschaft abschlie&szlig;en
            </a>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
import _ from 'lodash'
import EventBus from '../../event-bus'
import {Power2, TweenMax} from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default {
  name: 'your-sponsorship',
  computed: {
    ...mapGetters(['sponsorship']),
    grandTotal () {
      let grandTotal = 0
      if (this.pipesInBasket) {
        _.forEach(this.sponsorship.pipes, (pipe) => {
          grandTotal += pipe.price.amount
        })
      }
      return grandTotal
    },
    pipesInBasket () {
      return typeof this.sponsorship.pipes[0].id !== 'undefined'
    }
  },
  methods: {
    removePipe (changedPipe) {
      this.$store.dispatch('removePipe', changedPipe.id)
      this.$store.dispatch('updateSponsorship', {
        action: 'removePipe',
        pipe: changedPipe,
        sponsor: undefined,
        grandTotal: this.grandTotal
      })
    },
    showCheckout (show) {
      EventBus.$emit('SHOW_CHECKOUT', show)
      TweenMax.to(window, 2, {scrollTo: '#checkout-sponsorship', ease: Power2.easeOut})
    }
  },
  mounted () {
    EventBus.$on('RESET_CHOSEN_PIPES', (payload) => {
      // console.info(payload)
      _.each(payload, (pipe) => {
        this.removePipe(pipe)
      })
    })
  },
  watch: {
    pipesInBasket (newValue, oldValue) {
      if (!newValue) {
        this.showCheckout(false)
        TweenMax.to(window, 2, {scrollTo: '#choose-pipe', ease: Power2.easeOut})
      } else {
        TweenMax.to(window, 2, {scrollTo: '#your-sponsorship', ease: Power2.easeOut})
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  #your-sponsorship {
    background-color: transparentize($color-light-blue, 0.5);
    .uk-table {
      table-layout: fixed;
      thead {
        th {
          &.price {
            text-align: right;
          }
        }
      }
      td {
        a {
          .uk-icon-button {
            margin-left: 0.5em;
            background-color: $color-dark-blue;
            color: white;
          }
        }
        &.register {
          white-space: nowrap;
        }
        &.price {
          @media (min-width: $breakpoint-medium) {
            text-align: right;
          }
        }
        &.remove {
          text-align: right;
        }
        &#grand-total {
          text-align: center;
        }
      }
      &.uk-table-responsive {
        tfoot {
          display: block;
          @media (min-width: $breakpoint-medium) {
            display: table-footer-group;
          }
        }
        tr {
          display: block;
          @media (min-width: $breakpoint-medium) {
            display: table-row;
          }
        }
        td {
          display: block;
          @media (min-width: $breakpoint-medium) {
            display: table-cell;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/YourSponsorship.vue